import { Controller } from "@hotwired/stimulus"

// Presets for the resort picker. "PRA only" reads the same list the PRA flow
// e-mails are gated on (PRA_FLOW_EMAILS_LOCATIONS), stamped onto each checkbox
// server-side, so the two never drift apart.
export default class extends Controller {
  static targets = ["resort", "count"]

  connect() {
    this.updateCount()
  }

  selectAll() {
    this.setAll(() => true)
  }

  selectNone() {
    this.setAll(() => false)
  }

  selectPra() {
    this.setAll((el) => el.dataset.pra === "true")
  }

  // Kim's Mailchimp audience: the PRA resorts plus Divine Creatures.
  selectAudience() {
    this.setAll((el) => el.dataset.audience === "true")
  }

  setAll(predicate) {
    this.resortTargets.forEach((el) => { el.checked = predicate(el) })
    this.updateCount()
  }

  updateCount() {
    const total = this.resortTargets.filter((el) => el.checked).length
    if (this.hasCountTarget) {
      this.countTarget.textContent = total === 1 ? "1 resort selected" : `${total} resorts selected`
    }
  }
}
